import React from 'react';
import { Helmet } from 'react-helmet';
import '../css/TermsConditions.css'; // Ensure this CSS file includes the new styles
import GoogleAnalytics from '../components/GoogleAnalytics';

const TermsConditions = () => {
  return (
    <div>
      <GoogleAnalytics/>
      <section
      className="page-title"
      style={{ backgroundImage: 'url(images/hero.jpg)' }}
    >
      <div className="auto-container">
        <div className="title-outer text-center">
          <h1 className="title">Terms & Conditions</h1>
        </div>
      </div>
    </section>

      <section className="terms-section">
        <div className="container">
          <div className="row g-0">
            {/* Text Content Column */}
            <div className="col-md-7">
              <div className="terms-content">
                <p><b className="highlight">1. Booking Confirmation:</b> All bookings with SHREE Tours & Travels (Shree Cabs) are confirmed upon successful payment and issuance of a booking reference number.</p>

                <p><b className="highlight">2. Payment:</b> Full payment is required at the time of booking. Payments can be made through our website or at our authorized offices.</p>

                <p><b className="highlight">3. Cancellation and Rescheduling:</b> Cancellations and rescheduling requests are subject to our cancellation policy. Fees may apply based on the timing of the request.</p>

                <p><b className="highlight">4. Passenger Responsibility:</b> Passengers must carry valid identification and booking confirmation. We reserve the right to refuse service without proper documentation.</p>


                <p><b className="highlight">5. Travel Insurance:</b> We recommend purchasing travel insurance to cover unforeseen circumstances during your trip.</p>

                <p><b className="highlight">6. Safety Regulations:</b> Passengers must adhere to all safety regulations and follow instructions from our staff.</p>

                <p><b className="highlight">7. Changes to Itinerary:</b> SHREE Tours & Travels (Shree Cabs) reserves the right to alter itineraries due to unforeseen circumstances beyond our control.</p>

                <p><b className="highlight">8. Refusal of Service:</b> We may refuse service to passengers exhibiting disruptive behavior or violating our terms of service.</p>

                <p><b className="highlight">9. Jurisdiction:</b> These terms are governed by the laws of India. Any disputes will be resolved in the jurisdiction of Mumbai.</p>

                <h3>General Policy</h3>
                <p><b className="highlight">Booking Procedure:</b> Customers can book services through our website or by contacting our customer service.</p>
                <p><b className="highlight">Customer Support:</b> Our support team is available to assist with any inquiries and requests regarding bookings.</p>

                <h3>Refund Policy</h3>
                <p><b className="highlight"></b> • If you cancel the trip, the cancellation charges will be applicable as per the above mentioned cancellation and refund policy of Shree Cabs.</p>
                <p><b className="highlight"></b> • If eligible for refunds based on the “Cancellation & Refund Policy” as mentioned above, the refund will be processed within 5-7 working days.</p>
              </div>
            </div>

        
          </div>

          <div className="contact-info">
            <h2>Contact Us</h2>
            <p>If you have any questions regarding our terms, please reach out:</p>
            <ul>
              <li><b>Phone:</b> <a href="tel:+919594917913">+91 9594917913</a></li>
           
              <li><b>Email:</b> <a href="mailto:booking@shreecabs24.com">booking@shreecabs24.com</a></li>
            </ul>
          </div>
        </div>
      </section>
    </div>
  );
};

export default TermsConditions;
